webpackJsonp([1],{

/***/ "./colors.json":
/***/ (function(module, exports) {

module.exports = {"baseBg":"#fefefe","baseText":"#222","buttonBg":"#d14210","buttonText":"#fefefe","linkColor":"#0974bc","borderColor":"#848b95","goodResult":"#a1c454","badResult":"#c45454"}

/***/ }),

/***/ "./frontend/components/App.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

__webpack_require__("./node_modules/whatwg-fetch/fetch.js");

var _AppHeader = __webpack_require__("./frontend/components/AppHeader.jsx");

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _AppFooter = __webpack_require__("./frontend/components/AppFooter.jsx");

var _AppFooter2 = _interopRequireDefault(_AppFooter);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Test = __webpack_require__("./frontend/components/Test.jsx");

var _Test2 = _interopRequireDefault(_Test);

var _markdownToJsx = __webpack_require__("./node_modules/markdown-to-jsx/dist/esm.js");

var _markdownToJsx2 = _interopRequireDefault(_markdownToJsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppContainer = _styledComponents2.default.div.withConfig({
    displayName: "App__AppContainer"
})(["background:", ";color:", ";display:flex;flex-direction:column;min-height:calc(100vh - 36px);"], function (props) {
    return props.theme.baseBg;
}, function (props) {
    return props.theme.baseText;
});

var AppContent = _styledComponents2.default.div.withConfig({
    displayName: "App__AppContent"
})(["display:flex;flex-direction:column;padding:1rem 0;flex:1 0 auto;@media print{padding:0;}"]);

var TextContainer = _styledComponents2.default.div.withConfig({
    displayName: "App__TextContainer"
})(["padding:1rem 10vw;a{color:", ";cursor:pointer;text-decoration:underline;white-space:nowrap;&:hover{text-decoration:underline;}}@media (", "){padding:1rem;}@media print{display:none;}"], function (props) {
    return props.theme.linkColor;
}, function (props) {
    return props.theme.breakpoint;
});

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                AppContainer,
                null,
                _react2.default.createElement(_AppHeader2.default, { title: this.props.settings.i18n.title }),
                _react2.default.createElement(
                    AppContent,
                    null,
                    _react2.default.createElement(
                        TextContainer,
                        null,
                        _react2.default.createElement(
                            _markdownToJsx2.default,
                            null,
                            this.props.settings.i18n.intro.join("\n\n")
                        )
                    ),
                    _react2.default.createElement(_Test2.default, { settings: this.props.settings })
                ),
                _react2.default.createElement(_AppFooter2.default, null)
            );
        }
    }]);

    return App;
}(_react2.default.Component);

exports.default = App;

/***/ }),

/***/ "./frontend/components/AppFooter.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _eu = __webpack_require__("./frontend/images/eu.png");

var _eu2 = _interopRequireDefault(_eu);

var _mpr = __webpack_require__("./frontend/images/mpr.png");

var _mpr2 = _interopRequireDefault(_mpr);

var _moqos = __webpack_require__("./frontend/images/moqos.png");

var _moqos2 = _interopRequireDefault(_moqos);

var _cznic = __webpack_require__("./frontend/images/cznic.png");

var _cznic2 = _interopRequireDefault(_cznic);

var _cef = __webpack_require__("./frontend/images/cef.png");

var _cef2 = _interopRequireDefault(_cef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = _styledComponents2.default.footer.withConfig({
    displayName: "AppFooter__Container"
})(["margin-top:10vh;@media print{display:none;}"]);

var LogoCEF = _styledComponents2.default.div.withConfig({
    displayName: "AppFooter__LogoCEF"
})(["display:flex;justify-content:center;flex-wrap:wrap;img{height:3em;margin-bottom:2rem;max-width:80%;object-fit:contain;}"]);

var LogoContainer = _styledComponents2.default.div.withConfig({
    displayName: "AppFooter__LogoContainer"
})(["display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:2rem;img{height:3.5em;margin-bottom:2rem;max-width:80%;object-fit:contain;&:not(:last-child){margin-right:2rem;}}"]);

var FooterText = _styledComponents2.default.p.withConfig({
    displayName: "AppFooter__FooterText"
})(["border-bottom:0.1em solid ", ";text-align:center;padding:1rem;margin-bottom:2rem;"], function (props) {
    return props.theme.borderColor;
});

var AppFooter = function (_React$Component) {
    _inherits(AppFooter, _React$Component);

    function AppFooter() {
        _classCallCheck(this, AppFooter);

        return _possibleConstructorReturn(this, (AppFooter.__proto__ || Object.getPrototypeOf(AppFooter)).apply(this, arguments));
    }

    _createClass(AppFooter, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                Container,
                null,
                _react2.default.createElement(
                    FooterText,
                    null,
                    "Kontakt: ",
                    _react2.default.createElement(
                        "a",
                        { href: "mailto:standardkonektivity@nic.cz" },
                        "standardkonektivity@nic.cz"
                    ),
                    ". Podporovan\xE9 prohl\xED\u017Ee\u010De: Chrome/Chromium\xA040+, Firefox\xA045+, Edge\xA079+."
                ),
                _react2.default.createElement(
                    LogoContainer,
                    null,
                    _react2.default.createElement("img", { src: _mpr2.default, alt: "logo MPR" }),
                    _react2.default.createElement("img", { src: _moqos2.default, alt: "logo MoQos" }),
                    _react2.default.createElement("img", { src: _eu2.default, alt: "logo EU" }),
                    _react2.default.createElement("img", { src: _cznic2.default, alt: "logo CZ.NIC" })
                ),
                _react2.default.createElement(
                    LogoCEF,
                    null,
                    _react2.default.createElement("img", { src: _cef2.default, alt: "logo CEF" })
                )
            );
        }
    }]);

    return AppFooter;
}(_react2.default.Component);

exports.default = AppFooter;

/***/ }),

/***/ "./frontend/components/AppHeader.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = __webpack_require__("./node_modules/color/index.js");

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = _styledComponents2.default.header.withConfig({
    displayName: "AppHeader__Container"
})(["border-bottom:0.1em solid ", ";color:", ";font-weight:bolder;padding:1rem 10vw;user-select:none;font-size:1.5em;@media (", "){padding:1rem;}@media print{font-size:1em;padding:0 1rem 0.25rem;}"], function (props) {
    return props.theme.borderColor;
}, function (props) {
    return props.theme.borderColor;
}, function (props) {
    return props.theme.breakpoint;
});

var AppHeader = function (_React$Component) {
    _inherits(AppHeader, _React$Component);

    function AppHeader() {
        _classCallCheck(this, AppHeader);

        return _possibleConstructorReturn(this, (AppHeader.__proto__ || Object.getPrototypeOf(AppHeader)).apply(this, arguments));
    }

    _createClass(AppHeader, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                Container,
                null,
                _react2.default.createElement(
                    "h1",
                    null,
                    this.props.title
                )
            );
        }
    }]);

    return AppHeader;
}(_react2.default.Component);

exports.default = AppHeader;

/***/ }),

/***/ "./frontend/components/ConnectionTest.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _NetmetrEnded = __webpack_require__("./frontend/components/NetmetrEnded.jsx");

var _NetmetrEnded2 = _interopRequireDefault(_NetmetrEnded);

var _TestResultBlock = __webpack_require__("./frontend/components/TestResultBlock.jsx");

var _TestResultBlock2 = _interopRequireDefault(_TestResultBlock);

var _TestTitle = __webpack_require__("./frontend/components/TestTitle.jsx");

var _TestTitle2 = _interopRequireDefault(_TestTitle);

var _loading = __webpack_require__("./frontend/utils/loading.js");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import NetmetrWebTest from "./NetmetrWebTest.jsx";


var ConnectionTest = function (_React$Component) {
    _inherits(ConnectionTest, _React$Component);

    function ConnectionTest(props) {
        _classCallCheck(this, ConnectionTest);

        var _this = _possibleConstructorReturn(this, (ConnectionTest.__proto__ || Object.getPrototypeOf(ConnectionTest)).call(this, props));

        _this.state = {
            testsRunning: true,
            testsFinished: false,
            saving: false,
            saved: false,
            results: {},
            details: {}
        };
        return _this;
    }

    _createClass(ConnectionTest, [{
        key: "formatValue",
        value: function formatValue(value) {
            if (typeof value === "boolean") {
                return value ? "✓" : "✗";
            } else {
                if (value === "ok") return "✓";
                if (value === "fail") return "✗";
                if (value === "off") return "✗";
                return value;
            }
        }
    }, {
        key: "storeTestResult",
        value: function storeTestResult(name, result) {
            var st = this.state;
            if (typeof result === "string") {
                // "ok", "false", "off"
                st.results[name] = result;
            } else if (result.state && result.details) {
                // {status: "ok", details: "…"}
                st.results[name] = result.state;
                st.details[name] = result.details;
            } else if (result.ip) {
                // json from /api/ripe_ip_info/
                st.results[name] = result;
            }

            this.setState(st);

            if (name === "ipv4" && result != "ok") {
                this.storeNetmetrResult("ipv4", null);
            }

            if (name === "ipv6" && result != "ok") {
                this.storeNetmetrResult("ipv6", null);
            }

            if (Object.keys(st.results).length === this.props.settings.connectionTests.length) {
                this.setState({
                    testsRunning: false,
                    testsFinished: true
                });
                this.saveResult();
            }
        }
    }, {
        key: "getTestResult",
        value: function getTestResult(testName) {
            var component = this;
            var testClass = new (__webpack_require__("./frontend/connection_tests recursive ^\\.\\/.*\\.js$")("./" + testName + ".js"))();
            testClass.getState({
                url: component.props.settings.urls[testName],
                websiteUrl: component.props.websiteUrl
            }).then(function (result) {
                component.storeTestResult(testName, result);
            });
        }
    }, {
        key: "storeNetmetrResult",
        value: function storeNetmetrResult(protocol, data) {
            this.setState(_defineProperty({}, "netmetr-" + protocol, data));
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var component = this;
            component.props.settings.connectionTests.forEach(function (testName) {
                component.getTestResult(testName);
            });
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.runNetmetrIfItShould();
            this.saveResult();
        }
    }, {
        key: "runNetmetrIfItShould",
        value: function runNetmetrIfItShould() {
            if (this.state.testsFinished) {
                if (this.state.results.ipv4 === "ok" && this.refs.hasOwnProperty("netmetr-ipv4") && !this.state.hasOwnProperty("netmetr-ipv4")) {
                    this.refs["netmetr-ipv4"].runSpeedtest();
                }
                if (this.state.results.ipv6 === "ok" && this.refs.hasOwnProperty("netmetr-ipv6") && this.state.hasOwnProperty("netmetr-ipv4") && !this.state.hasOwnProperty("netmetr-ipv6")) {
                    this.refs["netmetr-ipv6"].runSpeedtest();
                }
            }
        }
    }, {
        key: "saveResult",
        value: function saveResult() {
            var component = this;
            if (!this.state.saving && !this.state.saved && this.state.testsFinished && this.state.hasOwnProperty("netmetr-ipv4") && this.state.hasOwnProperty("netmetr-ipv6")) {
                component.setState({
                    saving: true
                });

                var payload = {
                    has_ipv4: this.state.results.ipv4 === "ok" ? true : false,
                    has_ipv6: this.state.results.ipv6 === "ok" ? true : false,
                    has_dnssec_rsa: this.state.results.rsa === "ok" ? true : false,
                    has_dnssec_ecdsa: this.state.results.ecdsa === "ok" ? true : false,
                    has_fenix: this.state.results.fenix === "ok" ? true : false,
                    has_eduroam: this.state.results.eduroam === "ok" ? true : false,
                    user_ipv4: this.state.results.ipv4Address !== "–" ? this.state.results.ipv4Address.ip || null : null,
                    user_ipv6: this.state.results.ipv6Address !== "–" ? this.state.results.ipv6Address.ip || null : null,
                    ripe_netname_ipv4: this.state.results.ipv4Address !== "–" ? this.state.results.ipv4Address.netname : null,
                    ripe_netname_ipv6: this.state.results.ipv6Address !== "–" ? this.state.results.ipv6Address.netname : null,
                    ripe_link_ipv4: this.state.results.ipv4Address !== "–" ? this.state.results.ipv4Address.link : null,
                    ripe_link_ipv6: this.state.results.ipv6Address !== "–" ? this.state.results.ipv6Address.link : null
                };

                if (this.state["netmetr-ipv4"] != null && this.state["netmetr-ipv4"].open_test_uuid) {
                    payload["netmetr_uuid_ipv4"] = this.state["netmetr-ipv4"].open_test_uuid;
                    payload["speed_ipv4_down"] = this.state["netmetr-ipv4"].download_kbit / 1000;
                    payload["speed_ipv4_up"] = this.state["netmetr-ipv4"].upload_kbit / 1000;
                    payload["ping_ipv4"] = this.state["netmetr-ipv4"].ping_ms;
                }

                if (this.state["netmetr-ipv6"] != null && this.state["netmetr-ipv6"].open_test_uuid) {
                    payload["netmetr_uuid_ipv6"] = this.state["netmetr-ipv6"].open_test_uuid;
                    payload["speed_ipv6_down"] = this.state["netmetr-ipv6"].download_kbit / 1000;
                    payload["speed_ipv6_up"] = this.state["netmetr-ipv6"].upload_kbit / 1000;
                    payload["ping_ipv6"] = this.state["netmetr-ipv6"].ping_ms;
                }

                fetch(this.props.settings.urls.api + "connection/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    component.props.storeTest("connectionTest", json);
                    component.setState({
                        saving: false,
                        saved: true,
                        testId: json.id
                    });
                }).catch(function () {
                    component.setState({
                        saving: false,
                        saved: false
                    });
                });
            }
        }
    }, {
        key: "isResultGood",
        value: function isResultGood(result) {
            if (result === "fail" || result === "off") {
                return false;
            } else if (result === "ok") {
                return true;
            } else {
                return null;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_TestTitle2.default, {
                    text: this.props.settings.i18n.testTitles["connection"]
                }),
                this.props.settings.connectionTests.map(function (testName) {
                    return _react2.default.createElement(_TestResultBlock2.default, {
                        result: _this2.state.results[testName] ? _this2.formatValue(_this2.state.results[testName]) : _react2.default.createElement(_loading2.default, null),
                        details: _this2.state.details[testName] || null,
                        name: _this2.props.settings.i18n.testLabels.connection[testName],
                        good: _this2.isResultGood(_this2.state.results[testName]),
                        key: testName
                    });
                }),
                this.props.settings.netmetr.protocols.map(function (protocol) {
                    if ( /* this.state["netmetr-" + protocol] !== null */true) {
                        return _react2.default.createElement(
                            "div",
                            { key: "netmetr-" + protocol },
                            _react2.default.createElement(_TestTitle2.default, {
                                text: _this2.props.settings.i18n.testTitles["netmetr-" + protocol]
                            }),
                            _react2.default.createElement(_NetmetrEnded2.default, { message: _this2.props.settings.i18n.netmetrEnded })
                        );
                    }
                }),
                _react2.default.createElement(_TestTitle2.default, {
                    text: this.props.settings.i18n.testTitles["speed-info"] }),
                _react2.default.createElement(
                    "p",
                    null,
                    this.props.settings.i18n.netmetrEndedDetails
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    this.props.settings.i18n.altSpeedtests.map(function (st) {
                        return _react2.default.createElement(
                            "span",
                            null,
                            _react2.default.createElement(
                                "a",
                                { href: st.url },
                                st.name
                            ),
                            " \u2014 ",
                            _react2.default.createElement(
                                "span",
                                null,
                                st.desc
                            ),
                            _react2.default.createElement("br", null)
                        );
                    })
                )
            );
        }
    }]);

    return ConnectionTest;
}(_react2.default.Component);

exports.default = ConnectionTest;

/***/ }),

/***/ "./frontend/components/Link.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyledLink = _styledComponents2.default.a.withConfig({
    displayName: "Link__StyledLink"
})(["color:", ";cursor:pointer;text-decoration:underline;white-space:nowrap;&:hover{text-decoration:underline;}&.netmetr{@media print{color:transparent;&::after{color:", ";display:inline-block;content:attr(href);font-size:0.8em;}}}"], function (props) {
    return props.theme.linkColor;
}, function (props) {
    return props.theme.linkColor;
});

var Link = function (_React$Component) {
    _inherits(Link, _React$Component);

    function Link() {
        _classCallCheck(this, Link);

        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
    }

    _createClass(Link, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                StyledLink,
                {
                    className: this.props.url.indexOf("netmetr") > -1 ? "netmetr" : null,
                    href: this.props.url,
                    title: this.props.title,
                    target: this.props.newWindow ? "_blank" : null
                },
                this.props.text
            );
        }
    }]);

    return Link;
}(_react2.default.Component);

exports.default = Link;

/***/ }),

/***/ "./frontend/components/NetmetrEnded.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NetmetrEnded = function (_React$Component) {
    _inherits(NetmetrEnded, _React$Component);

    function NetmetrEnded(props) {
        _classCallCheck(this, NetmetrEnded);

        return _possibleConstructorReturn(this, (NetmetrEnded.__proto__ || Object.getPrototypeOf(NetmetrEnded)).call(this, props));
    }

    _createClass(NetmetrEnded, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "p",
                    null,
                    this.props.message
                )
            );
        }
    }]);

    return NetmetrEnded;
}(_react2.default.Component);

exports.default = NetmetrEnded;

/***/ }),

/***/ "./frontend/components/Test.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _ConnectionTest = __webpack_require__("./frontend/components/ConnectionTest.jsx");

var _ConnectionTest2 = _interopRequireDefault(_ConnectionTest);

var _WebsiteTest = __webpack_require__("./frontend/components/WebsiteTest.jsx");

var _WebsiteTest2 = _interopRequireDefault(_WebsiteTest);

var _TestTitle = __webpack_require__("./frontend/components/TestTitle.jsx");

var _TestTitle2 = _interopRequireDefault(_TestTitle);

var _TestResultBlock = __webpack_require__("./frontend/components/TestResultBlock.jsx");

var _TestResultBlock2 = _interopRequireDefault(_TestResultBlock);

var _loading = __webpack_require__("./frontend/utils/loading.js");

var _loading2 = _interopRequireDefault(_loading);

var _button = __webpack_require__("./frontend/utils/button.js");

var _button2 = _interopRequireDefault(_button);

var _input = __webpack_require__("./frontend/utils/input.js");

var _input2 = _interopRequireDefault(_input);

var _container = __webpack_require__("./frontend/utils/container.js");

var _container2 = _interopRequireDefault(_container);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var anim = (0, _styledComponents.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);

var TestContainer = _styledComponents2.default.div.withConfig({
    displayName: "Test__TestContainer"
})(["display:flex;flex-direction:column;padding:1rem 10vw;animation:", " 0.33s 1 ease-out;@media (", "){padding:1rem;}@media print{padding:0 1rem;}"], anim, function (props) {
    return props.theme.breakpoint;
});

var ButtonContainer = _styledComponents2.default.div.withConfig({
    displayName: "Test__ButtonContainer"
})(["display:flex;align-items:center;justify-content:center;padding:1rem;@media print{display:none;}"]);

var IDText = _styledComponents2.default.span.withConfig({
    displayName: "Test__IDText"
})(["font-family:monospace;@media print{margin-right:1em;}"]);

var IDContainer = _styledComponents2.default.div.withConfig({
    displayName: "Test__IDContainer"
})(["display:flex;flex-direction:column;@media print{flex-direction:row;font-size:0.8em;}"]);

var DomainWarning = _styledComponents2.default.div.withConfig({
    displayName: "Test__DomainWarning"
})(["display:inline-block;text-align:center;color:", ";border:0.1em solid ", ";padding:0.5em;margin-top:-1em;animation:", " 0.33s 1 ease-out;@media (", "){margin-top:0;}"], function (props) {
    return props.theme.badResult;
}, function (props) {
    return props.theme.badResult;
}, anim, function (props) {
    return props.theme.breakpoint;
});

var Test = function (_React$Component) {
    _inherits(Test, _React$Component);

    function Test(props) {
        _classCallCheck(this, Test);

        var _this = _possibleConstructorReturn(this, (Test.__proto__ || Object.getPrototypeOf(Test)).call(this, props));

        _this.runTests = _this.runTests.bind(_this);
        _this.updateUrl = _this.updateUrl.bind(_this);
        _this.resetState = _this.resetState.bind(_this);
        _this.showPrintDialog = _this.showPrintDialog.bind(_this);
        _this.handleKeypress = _this.handleKeypress.bind(_this);
        _this.storeTest = _this.storeTest.bind(_this);
        _this.state = {
            testsRunning: false,
            domainWarningShown: false,
            websiteUrl: "",
            connectionTest: {},
            websiteTest: {}
        };
        return _this;
    }

    _createClass(Test, [{
        key: "runTests",
        value: function runTests() {
            var urlRegex = /^(?:https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
            if (this.state.websiteUrl && urlRegex.test(this.state.websiteUrl)) {
                this.setState({
                    testsRunning: true,
                    domainWarningShown: false
                });
            } else {
                this.setState({
                    domainWarningShown: true
                });
            }
        }
    }, {
        key: "updateUrl",
        value: function updateUrl(event) {
            this.setState({
                websiteUrl: event.target.value.toLowerCase(),
                domainWarningShown: false
            });
        }
    }, {
        key: "handleKeypress",
        value: function handleKeypress(event) {
            if (event.key === "Enter") {
                this.runTests();
            }
        }
    }, {
        key: "resetState",
        value: function resetState() {
            this.setState({
                testsRunning: false,
                domainWarningShown: false,
                connectionTest: {},
                websiteTest: {}
            });
        }
    }, {
        key: "storeTest",
        value: function storeTest(test, result) {
            this.setState(_defineProperty({}, test, result));
        }
    }, {
        key: "showPrintDialog",
        value: function showPrintDialog() {
            window.print();
        }
    }, {
        key: "render",
        value: function render() {
            var content = void 0;
            var domainWarning = void 0;

            if (this.state.domainWarningShown) {
                domainWarning = _react2.default.createElement(
                    DomainWarning,
                    null,
                    "Zadejte pros\xEDm URL nebo dom\xE9nu."
                );
            }

            if (!this.state.testsRunning) {
                content = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        _container2.default,
                        null,
                        _react2.default.createElement(_input2.default, {
                            ref: "websiteUrl",
                            placeholder: this.props.settings.i18n.inputPlaceholder,
                            "aria-label": this.props.settings.i18n.inputPlaceholder,
                            onChange: this.updateUrl,
                            onKeyPress: this.handleKeypress,
                            value: this.state.websiteUrl
                        }),
                        _react2.default.createElement(
                            _button2.default,
                            { onClick: this.runTests },
                            this.props.settings.i18n.runTests
                        )
                    ),
                    _react2.default.createElement(
                        _container2.default,
                        null,
                        domainWarning
                    )
                );
            }

            if (this.state.testsRunning) {
                content = _react2.default.createElement(
                    TestContainer,
                    null,
                    _react2.default.createElement(_ConnectionTest2.default, {
                        ref: "ConnectionTest",
                        settings: this.props.settings,
                        websiteUrl: this.state.websiteUrl,
                        storeTest: this.storeTest
                    }),
                    _react2.default.createElement(_WebsiteTest2.default, {
                        ref: "WebsiteTest",
                        settings: this.props.settings,
                        websiteUrl: this.state.websiteUrl,
                        storeTest: this.storeTest
                    }),
                    _react2.default.createElement(
                        ButtonContainer,
                        null,
                        _react2.default.createElement(
                            _button2.default,
                            { onClick: this.showPrintDialog },
                            this.props.settings.i18n.printDialog
                        ),
                        _react2.default.createElement(
                            _button2.default,
                            { onClick: this.resetState },
                            this.props.settings.i18n.resetState
                        )
                    )
                );
            }

            return content;
        }
    }]);

    return Test;
}(_react2.default.Component);

exports.default = Test;

/***/ }),

/***/ "./frontend/components/TestResultBlock.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Link = __webpack_require__("./frontend/components/Link.jsx");

var _Link2 = _interopRequireDefault(_Link);

var _info = __webpack_require__("./frontend/images/info.svg");

var _info2 = _interopRequireDefault(_info);

var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/lib/react-markdown.js");

var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);

var _colors = __webpack_require__("./frontend/utils/colors.js");

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyledBox = _styledComponents2.default.div.withConfig({
    displayName: "TestResultBlock__StyledBox"
})(["border-bottom:0.1em solid ", ";color:", ";display:flex;flex-flow:row wrap;overflow:hidden;@media print{border-color:", ";}"], function (props) {
    return props.theme.borderColor;
}, function (props) {
    return props.theme.baseText;
}, function (props) {
    return props.theme.lighten(props.theme.borderColor);
});

var TestName = _styledComponents2.default.div.withConfig({
    displayName: "TestResultBlock__TestName"
})(["padding:1rem;flex-grow:1;@media print{padding:0.25rem;}"]);

var TestResult = _styledComponents2.default.div.withConfig({
    displayName: "TestResultBlock__TestResult"
})(["padding:1rem;@media print{padding:0.25rem;}"]);

var DetailsToggle = _styledComponents2.default.button.withConfig({
    displayName: "TestResultBlock__DetailsToggle"
})(["border:0;opacity:0.6;transition:opacity 0.33s;width:1.2rem;height:1.2rem;cursor:pointer;background:transparent;margin-top:1rem;&:hover,&:focus{opacity:1;}img{width:100%;}@media print{display:none;}"]);

var TestDetails = _styledComponents2.default.div.withConfig({
    displayName: "TestResultBlock__TestDetails"
})(["padding:0 1rem 1rem;width:100%;p{margin:0;}ul,ul{list-style-position:inside;margin-left:0.5rem;}a{&,&:link,&:visited{color:", ";text-decoration:none;}&:hover,&:focus{text-decoration:underline;}}@media print{display:none;}"], _colors2.default.linkColor);

var Good = _styledComponents2.default.span.withConfig({
    displayName: "TestResultBlock__Good"
})(["color:", ";"], function (props) {
    return props.theme.goodResult;
});

var Bad = _styledComponents2.default.span.withConfig({
    displayName: "TestResultBlock__Bad"
})(["color:", ";"], function (props) {
    return props.theme.badResult;
});

var TestResultBlock = function (_React$Component) {
    _inherits(TestResultBlock, _React$Component);

    function TestResultBlock(props) {
        _classCallCheck(this, TestResultBlock);

        var _this = _possibleConstructorReturn(this, (TestResultBlock.__proto__ || Object.getPrototypeOf(TestResultBlock)).call(this, props));

        _this.state = {
            showingDetails: false
        };
        _this.toggleDetails = _this.toggleDetails.bind(_this);
        return _this;
    }

    _createClass(TestResultBlock, [{
        key: "toggleDetails",
        value: function toggleDetails() {
            this.setState({
                showingDetails: !this.state.showingDetails
            });
        }
    }, {
        key: "render",
        value: function render() {
            var result = this.props.result;

            if (this.props.good === true) {
                result = _react2.default.createElement(
                    Good,
                    null,
                    this.props.result
                );
            }

            if (this.props.good === false) {
                result = _react2.default.createElement(
                    Bad,
                    null,
                    this.props.result
                );
            }

            if (this.props.result.ip) {
                result = _react2.default.createElement(
                    "span",
                    null,
                    this.props.result.ip,
                    " (",
                    _react2.default.createElement(_Link2.default, { newWindow: true, text: this.props.result.netname, url: this.props.result.link }),
                    ")"
                );
            }

            return _react2.default.createElement(
                StyledBox,
                null,
                _react2.default.createElement(
                    TestName,
                    null,
                    this.props.name
                ),
                this.props.details ? _react2.default.createElement(
                    DetailsToggle,
                    { onClick: this.toggleDetails },
                    _react2.default.createElement("img", { src: _info2.default, alt: "?" })
                ) : null,
                _react2.default.createElement(
                    TestResult,
                    null,
                    result
                ),
                this.props.details && this.state.showingDetails ? _react2.default.createElement(
                    TestDetails,
                    null,
                    _react2.default.createElement(_reactMarkdown2.default, { source: this.props.details })
                ) : null
            );
        }
    }]);

    return TestResultBlock;
}(_react2.default.Component);

exports.default = TestResultBlock;

/***/ }),

/***/ "./frontend/components/TestTitle.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyledHeading = _styledComponents2.default.h2.withConfig({
    displayName: "TestTitle__StyledHeading"
})(["color:", ";white-space:nowrap;margin-top:2rem;@media print{margin-top:0.5rem;}"], function (props) {
    return props.theme.buttonBg;
});

var TestTitle = function (_React$Component) {
    _inherits(TestTitle, _React$Component);

    function TestTitle() {
        _classCallCheck(this, TestTitle);

        return _possibleConstructorReturn(this, (TestTitle.__proto__ || Object.getPrototypeOf(TestTitle)).apply(this, arguments));
    }

    _createClass(TestTitle, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                StyledHeading,
                null,
                this.props.text
            );
        }
    }]);

    return TestTitle;
}(_react2.default.Component);

exports.default = TestTitle;

/***/ }),

/***/ "./frontend/components/WebsiteTest.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _button = __webpack_require__("./frontend/utils/button.js");

var _button2 = _interopRequireDefault(_button);

var _input = __webpack_require__("./frontend/utils/input.js");

var _input2 = _interopRequireDefault(_input);

var _container = __webpack_require__("./frontend/utils/container.js");

var _container2 = _interopRequireDefault(_container);

var _TestResultBlock = __webpack_require__("./frontend/components/TestResultBlock.jsx");

var _TestResultBlock2 = _interopRequireDefault(_TestResultBlock);

var _loading = __webpack_require__("./frontend/utils/loading.js");

var _loading2 = _interopRequireDefault(_loading);

var _TestTitle = __webpack_require__("./frontend/components/TestTitle.jsx");

var _TestTitle2 = _interopRequireDefault(_TestTitle);

__webpack_require__("./node_modules/whatwg-fetch/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WebsiteTest = function (_React$Component) {
    _inherits(WebsiteTest, _React$Component);

    function WebsiteTest(props) {
        _classCallCheck(this, WebsiteTest);

        var _this = _possibleConstructorReturn(this, (WebsiteTest.__proto__ || Object.getPrototypeOf(WebsiteTest)).call(this, props));

        _this.state = {
            testsRunning: true,
            testsFinished: false,
            saving: false,
            saved: false
        };
        return _this;
    }

    _createClass(WebsiteTest, [{
        key: "getTestResult",
        value: function getTestResult() {
            var component = this;
            fetch(this.props.settings.urls.website + "?url=" + this.props.websiteUrl).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (data.hasOwnProperty("error")) {
                    component.setState({
                        message: component.props.settings.i18n.badUrl,
                        testsRunning: false,
                        testsFinished: true
                    });
                } else {
                    component.setState({
                        results: data,
                        testsRunning: false,
                        testsFinished: true
                    });
                    component.saveResult();
                }
            });
        }
    }, {
        key: "saveResult",
        value: function saveResult() {
            var component = this;
            if (!this.state.saving && !this.state.saved && this.state.testsFinished) {
                component.setState({
                    saving: true
                });

                var payload = {
                    has_ipv4: this.state.results.ipv4,
                    has_ipv6: this.state.results.ipv6,
                    has_dnssec: this.state.results.dnssec,
                    has_https: this.state.results.https,
                    domain: this.state.results.domain
                };

                fetch(this.props.settings.urls.api + "website/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    component.props.storeTest("websiteTest", json);
                    component.setState({
                        saving: false,
                        saved: true,
                        testId: json.id
                    });
                }).catch(function () {
                    component.setState({
                        saving: false,
                        saved: false
                    });
                });
            }
        }
    }, {
        key: "componentWillMount",
        value: function componentWillMount() {
            this.getTestResult();
        }
    }, {
        key: "formatValue",
        value: function formatValue(value) {
            if (typeof value === "boolean") {
                return value ? "✓" : "✗";
            } else {
                return value;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var content = null;

            if (this.state.hasOwnProperty("message")) {
                content = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(_TestResultBlock2.default, { name: this.state.message })
                );
            } else {
                content = _react2.default.createElement(
                    "div",
                    null,
                    this.props.settings.websiteTests.map(function (testName) {
                        return _react2.default.createElement(_TestResultBlock2.default, {
                            result: _this2.state.results && _this2.state.results.hasOwnProperty(testName) ? _this2.formatValue(_this2.state.results[testName]) : _react2.default.createElement(_loading2.default, null),
                            name: _this2.props.settings.i18n.testLabels.website[testName],
                            good: _this2.state.results && typeof _this2.state.results[testName] === "boolean" ? _this2.state.results[testName] : null,
                            key: testName
                        });
                    })
                );
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_TestTitle2.default, {
                    text: this.props.settings.i18n.testTitles["website"]
                }),
                content
            );
        }
    }]);

    return WebsiteTest;
}(_react2.default.Component);

exports.default = WebsiteTest;

/***/ }),

/***/ "./frontend/connection_tests recursive ^\\.\\/.*\\.js$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ecdsa.js": "./frontend/connection_tests/ecdsa.js",
	"./eduroam.js": "./frontend/connection_tests/eduroam.js",
	"./fenix.js": "./frontend/connection_tests/fenix.js",
	"./ipv4.js": "./frontend/connection_tests/ipv4.js",
	"./ipv4Address.js": "./frontend/connection_tests/ipv4Address.js",
	"./ipv6.js": "./frontend/connection_tests/ipv6.js",
	"./ipv6Address.js": "./frontend/connection_tests/ipv6Address.js",
	"./rsa.js": "./frontend/connection_tests/rsa.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./frontend/connection_tests recursive ^\\.\\/.*\\.js$";

/***/ }),

/***/ "./frontend/connection_tests/ecdsa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _rsa2 = __webpack_require__("./frontend/connection_tests/rsa.js");

var _rsa3 = _interopRequireDefault(_rsa2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_rsa) {
  _inherits(ecdsa, _rsa);

  function ecdsa() {
    _classCallCheck(this, ecdsa);

    return _possibleConstructorReturn(this, (ecdsa.__proto__ || Object.getPrototypeOf(ecdsa)).apply(this, arguments));
  }

  return ecdsa;
}(_rsa3.default);

/***/ }),

/***/ "./frontend/connection_tests/eduroam.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function eduroam() {
        _classCallCheck(this, eduroam);
    }

    _createClass(eduroam, [{
        key: "getState",
        value: function getState(options) {
            return new Promise(function (resolve, reject) {
                fetch(options.url + options.websiteUrl).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    if (json.eduroam === true) {
                        var details = json.orgs.map(function (org, index) {
                            return "**Organizace: *" + (typeof org["org_name"] === "string" ? org["org_name"] : "—") + "***\n\nRealmy" + (index === 0 ? " (klikněte pro více informací)" : "") + ":\n" + org["realms"].map(function (realm) {
                                return "- [" + realm + "](https://pripojovani.eduroam.cz/" + realm + ")";
                            }).join("\n");
                        }).join("\n\n");
                        resolve({
                            state: "ok",
                            details: details
                        });
                    } else {
                        resolve({
                            state: "fail",
                            details: "Pro Va\u0161i dom\xE9nu (URL [`" + options.websiteUrl + "`](https://pripojovani.eduroam.cz/" + options.websiteUrl + ")) nebyla v\xA0datab\xE1zi \u010Dlen\u016F [eduroam.cz](https://eduroam.cz) nalezena \u017E\xE1dn\xE1 shoda. Pokud jste p\u0159esto do s\xEDt\u011B eduroam p\u0159ipojeni, [kontaktujte](https://www.eduroam.cz/cs/kontakty) pros\xEDm sdru\u017Een\xED [CESNET](https://www.cesnet.cz)."
                        });
                    }
                }).catch(function () {
                    resolve("off");
                });
            });
        }
    }]);

    return eduroam;
}();

/***/ }),

/***/ "./frontend/connection_tests/fenix.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function fenix() {
        _classCallCheck(this, fenix);
    }

    _createClass(fenix, [{
        key: "getState",
        value: function getState(options) {
            return new Promise(function (resolve, reject) {
                fetch(options.url.ipv4).then(function (response) {
                    return response.json();
                }).then(function (json) {
                    if (json.result > 0) {
                        resolve("ok");
                    } else {
                        fetch(options.url.ipv6).then(function (response) {
                            return response.json();
                        }).then(function (json) {
                            if (json.result > 0) {
                                resolve("ok");
                            } else {
                                resolve("fail");
                            }
                        }).catch(function () {
                            resolve("fail");
                        });
                    }
                }).catch(function () {
                    resolve("off");
                });
            });
        }
    }]);

    return fenix;
}();

/***/ }),

/***/ "./frontend/connection_tests/ipv4.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ip = __webpack_require__("./frontend/utils/ip.js");

var ip = _interopRequireWildcard(_ip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function ipv4() {
        _classCallCheck(this, ipv4);
    }

    _createClass(ipv4, [{
        key: "getState",
        value: function getState() {
            return new Promise(function (resolve) {
                ip.getV4Data().then(function () {
                    resolve("ok");
                }).catch(function () {
                    resolve("fail");
                });
            });
        }
    }]);

    return ipv4;
}();

/***/ }),

/***/ "./frontend/connection_tests/ipv4Address.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ip = __webpack_require__("./frontend/utils/ip.js");

var ip = _interopRequireWildcard(_ip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function ipv4Address() {
        _classCallCheck(this, ipv4Address);
    }

    _createClass(ipv4Address, [{
        key: "getState",
        value: function getState() {
            return ip.getV4Data();
        }
    }]);

    return ipv4Address;
}();

/***/ }),

/***/ "./frontend/connection_tests/ipv6.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ip = __webpack_require__("./frontend/utils/ip.js");

var ip = _interopRequireWildcard(_ip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function ipv6() {
        _classCallCheck(this, ipv6);
    }

    _createClass(ipv6, [{
        key: "getState",
        value: function getState() {
            return new Promise(function (resolve) {
                ip.getV6Data().then(function () {
                    resolve("ok");
                }).catch(function () {
                    resolve("fail");
                });
            });
        }
    }]);

    return ipv6;
}();

/***/ }),

/***/ "./frontend/connection_tests/ipv6Address.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ip = __webpack_require__("./frontend/utils/ip.js");

var ip = _interopRequireWildcard(_ip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function ipv6Address() {
        _classCallCheck(this, ipv6Address);
    }

    _createClass(ipv6Address, [{
        key: "getState",
        value: function getState() {
            return ip.getV6Data();
        }
    }]);

    return ipv6Address;
}();

/***/ }),

/***/ "./frontend/connection_tests/rsa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function rsa() {
        _classCallCheck(this, rsa);
    }

    _createClass(rsa, [{
        key: "getState",
        value: function getState(options) {
            return new Promise(function (resolve, reject) {
                fetch(options.url + "?_=" + Date.now(), { cache: "no-cache" }).then(function () {
                    resolve("fail");
                }).catch(function () {
                    resolve("ok");
                });
            });
        }
    }]);

    return rsa;
}();

/***/ }),

/***/ "./frontend/images/cef.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cef.9d120b72ac5a4f9d4e02c8082cd4cdb7.png";

/***/ }),

/***/ "./frontend/images/cznic.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cznic.743272f357748ccd86073d8f7b5efdc2.png";

/***/ }),

/***/ "./frontend/images/eu.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eu.ed62a3b5c9bdfae20fea47d606807d03.png";

/***/ }),

/***/ "./frontend/images/info.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "info.53fb9ae90b06dbdb1950f548accf9ad7.svg";

/***/ }),

/***/ "./frontend/images/moqos.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "moqos.42b249e2ee628fa7eec974f5635f22bd.png";

/***/ }),

/***/ "./frontend/images/mpr.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mpr.1eb0d585628ce109a4cf70cb83fc8e2e.png";

/***/ }),

/***/ "./frontend/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    html {\n        &,\n        & * {\n            border: 0;\n            box-sizing: border-box;\n            font-size: 1em;\n            margin: 0;\n            padding: 0;\n        }\n    }\n\n    body {\n        font: 12pt/1.5em sans-serif; /* stylelint-disable-line unit-whitelist */\n    }\n\n    p,\n    ul,\n    ol,\n    table,\n    dl {\n        margin: 0 0 1rem;\n    }\n\n    #tb-projects-bar {\n        @media print {\n            display: none !important;\n        }\n    }\n"], ["\n    html {\n        &,\n        & * {\n            border: 0;\n            box-sizing: border-box;\n            font-size: 1em;\n            margin: 0;\n            padding: 0;\n        }\n    }\n\n    body {\n        font: 12pt/1.5em sans-serif; /* stylelint-disable-line unit-whitelist */\n    }\n\n    p,\n    ul,\n    ol,\n    table,\n    dl {\n        margin: 0 0 1rem;\n    }\n\n    #tb-projects-bar {\n        @media print {\n            display: none !important;\n        }\n    }\n"]);

__webpack_require__("./node_modules/babel-polyfill/lib/index.js");

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _settings = __webpack_require__("./settings.json");

var _settings2 = _interopRequireDefault(_settings);

var _ravenJs = __webpack_require__("./node_modules/raven-js/src/singleton.js");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _colors = __webpack_require__("./frontend/utils/colors.js");

var _colors2 = _interopRequireDefault(_colors);

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _App = __webpack_require__("./frontend/components/App.jsx");

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

_ravenJs2.default.config(_settings2.default.sentryDsn).install();

(0, _styledComponents.injectGlobal)(_templateObject);

var ThemedApp = function (_React$Component) {
    _inherits(ThemedApp, _React$Component);

    function ThemedApp() {
        _classCallCheck(this, ThemedApp);

        return _possibleConstructorReturn(this, (ThemedApp.__proto__ || Object.getPrototypeOf(ThemedApp)).apply(this, arguments));
    }

    _createClass(ThemedApp, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _styledComponents.ThemeProvider,
                { theme: _colors2.default },
                _react2.default.createElement(_App2.default, { settings: _settings2.default })
            );
        }
    }]);

    return ThemedApp;
}(_react2.default.Component);

_reactDom2.default.render(_react2.default.createElement(ThemedApp, null), document.getElementById("app"));

document.addEventListener("DOMContentLoaded", function () {
    var lang = document.documentElement.lang || window.navigator.userLanguage || window.navigator.language;

    if (/^.*cs.*$/.test(lang)) {
        window.nicWidgetsBar = new nicWidgets.topBar("CS");
    } else if (/^.*en.*$/.test(lang)) {
        window.nicWidgetsBar = new nicWidgets.topBar("EN");
    } else {
        window.nicWidgetsBar = new nicWidgets.topBar("EN"); // fall back to default
    }
});

/***/ }),

/***/ "./frontend/utils/button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _styledComponents2.default.button.withConfig({
    displayName: "button__exports"
})(["background:transparent;border-radius:0.2em;border:0.1em solid ", ";color:", ";cursor:pointer;font-size:1em;padding:1rem;user-select:none;white-space:nowrap;&:not(:last-child){margin-right:1rem;}&:hover{background:", ";color:", ";}"], function (props) {
    return props.theme.buttonBg;
}, function (props) {
    return props.theme.buttonBg;
}, function (props) {
    return props.theme.buttonBg;
}, function (props) {
    return props.theme.buttonText;
});

/***/ }),

/***/ "./frontend/utils/colors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _color = __webpack_require__("./node_modules/color/index.js");

var _color2 = _interopRequireDefault(_color);

var _colors = __webpack_require__("./colors.json");

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Object.assign(_colors2.default, {
    darken: function darken(colorDef) {
        return (0, _color2.default)(colorDef).darken(0.5).string();
    },
    lighten: function lighten(colorDef) {
        return (0, _color2.default)(colorDef).lighten(0.5).string();
    },
    breakpoint: "screen and (max-width: 75em)"
});

/***/ }),

/***/ "./frontend/utils/container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
    displayName: "container"
})(["padding:0 10vw 1rem;display:flex;justify-content:center;flex-wrap:wrap;align-items:center;@media (", "){padding:0 1rem 1rem;}"], function (props) {
    return props.theme.breakpoint;
});

/***/ }),

/***/ "./frontend/utils/input.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _styledComponents2.default.input.withConfig({
    displayName: "input__exports"
})(["background:", ";padding:1rem;margin:1rem;border:0.1em solid ", ";&::placeholder{color:", ";}"], function (props) {
    return props.theme.baseBg;
}, function (props) {
    return props.theme.borderColor;
}, function (props) {
    return props.theme.borderColor;
});

/***/ }),

/***/ "./frontend/utils/ip.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getV4Data = getV4Data;
exports.getV6Data = getV6Data;

__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

var _settings = __webpack_require__("./settings.json");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var v4_data = null;
var v6_data = null;
var v4_cbs = [];
var v6_cbs = [];

function doAll(data, cbs, cb_name) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = cbs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            c[cb_name](data);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

fetch(_settings2.default.urls.ipv4).then(function (response) {
    return response.json();
}).then(function (response) {
    return doAll(v4_data = response, v4_cbs, "resolve");
}).catch(function () {
    return doAll(v4_data = false, v4_cbs, "reject");
});
fetch(_settings2.default.urls.ipv6).then(function (response) {
    return response.json();
}).then(function (response) {
    return doAll(v6_data = response, v6_cbs, "resolve");
}).catch(function () {
    return doAll(v6_data = false, v6_cbs, "reject");
});

function getData(data, cbs) {
    return new Promise(function (resolve, reject) {
        if (data === false) {
            reject(data);
        } else if (data) {
            resolve(data);
        } else {
            cbs.push({ resolve: resolve, reject: reject });
        }
    });
}

function getV4Data() {
    return getData(v4_data, v4_cbs);
}

function getV6Data() {
    return getData(v6_data, v6_cbs);
}

/***/ }),

/***/ "./frontend/utils/loading.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _styledComponents = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var anim = (0, _styledComponents.keyframes)(["0%,80%,100%{box-shadow:0 2.5em 0 -1.3em;}40%{box-shadow:0 2.5em 0 0;}"]);

module.exports = _styledComponents2.default.span.withConfig({
    displayName: "loading__exports"
})(["display:inline-block;position:absolute;color:", ";margin:-2em auto 0 -2em;transform:translateZ(0);animation-delay:-0.16s;&,&::before,&::after{border-radius:50%;width:0.5em;height:0.5em;animation-fill-mode:both;animation-name:", ";animation-duration:1.8s;animation-iteration-count:infinite;animation-timing-function:ease-in-out;}&::before,&::after{content:\"\";position:absolute;top:0;}&::before{left:-0.75em;animation-delay:-0.32s;}&::after{left:0.75em;}@media print{display:none;}"], function (props) {
    return props.theme.borderColor;
}, anim);

/***/ }),

/***/ "./settings.json":
/***/ (function(module, exports) {

module.exports = {"sentryDsn":"https://3630e0151c4b444e9384d6f2140b7051@sentry.labs.nic.cz/21","urls":{"api":"/api/","rsa":"https://www.rhybar.cz/files/CORS/projects-bar/basic-datafile.json","ecdsa":"https://bad-ecdsa.test-ipv6.cz/","fenix":{"ipv4":"https://ipv4-widget.nic.cz/","ipv6":"https://ipv6-widget.nic.cz/"},"ipv6":"https://ipv6.standardkonektivity.cz/api/ip/","ipv4":"https://ipv4.standardkonektivity.cz/api/ip/","eduroam":"/api/eduroam/?url=","website":"/api/website_status/"},"netmetr":{"cookieName":"netmetr_uuid","cookieDomain":"localhost","backendUrl":{"ipv4":"https://ipv4.control.netmetr.cz/","ipv6":"https://ipv6.control.netmetr.cz/"},"testUrl":"/netmetr_test/?start","resultUrl":"https://www.netmetr.cz/cs/detail.html","protocols":["ipv4","ipv6"],"goodSpeedRatio":0.3,"timeout":60},"connectionTests":["ipv4","ipv4Address","ipv6","ipv6Address","rsa","ecdsa","fenix","eduroam"],"websiteTests":["domain","ipv4","ipv6","dnssec","https"],"i18n":{"title":"Standard konektivity škol","netmetrLink":"odkaz ↗","runTests":"Otestovat připojení","resetState":"Nový test","printDialog":"Tisk/export","inputPlaceholder":"adresa webu","timestamp":"Čas testu","domain":"Doména","dnssec":"DNSSEC","ipv6":"IPv6","https":"HTTPS","eduroam":"eduroam.cz","ip":"IP adresa","rsa":"DNSSEC RSA","ecdsa":"DNSSEC ECDSA","fenix":"Fenix","netmetrEnded":"Nedostupné.","netmetrEndedDetails":"Služba NetMetr, která byla Standardem konektivity využívána k testování rychlosti, byla k 30. dubnu 2022 ukončena. Pro testování rychlosti, prosíme, využijte některou z alternativních služeb:","netmetr4":"NetMetr IPv4","netmetr6":"NetMetr IPv6","netmetrFailed":"Při měření došlo k chybě.","netmetrRetry":"Zkusit znovu","netmetrSkip":"Přeskočit","netmetrWaiting":"Čekám na výsledek předchozího testu…","download4":"Download IPv4","upload4":"Upload IPv4","downup4":"Rozdíl rychlostí IPv4","ping4":"Ping IPv4","download6":"Download IPv6","upload6":"Upload IPv6","downup6":"Rozdíl rychlostí IPv6","ping6":"Ping IPv6","badUrl":"Chybný formát adresy","savedResult":"Uložený výsledek testu","connectionTestId":"ID testu připojení","websiteTestId":"ID testu webu","testTimes":"Časy uložení výsledků","testTitles":{"connection":"Vaše připojení k internetu","netmetr-ipv4":"Rychlost IPv4","netmetr-ipv6":"Rychlost IPv6","speed-info":"Poznámka","website":"Váš web"},"altSpeedtests":[{"name":"NetTest.cz","url":"https://nettest.cz/","desc":"Provozováno Českým telekomunikačním úřadem. Poskytuje možnost certifikovaného měření."},{"name":"LibreSpeed.org","url":"https://librespeed.org/","desc":"Open-source test rychlosti. Zprovoznitelný na vlastní infrastruktuře."}],"testLabels":{"connection":{"ip":"Vaše IP adresa","ipv4":"IPv4 konektivita","ipv6":"IPv6 konektivita","ipv4Address":"IPv4 adresa","ipv6Address":"IPv6 adresa","rsa":"DNSSEC RSA","ecdsa":"DNSSEC ECDSA","fenix":"Připojeno do sítě Fenix","eduroam":"Organizace připojena k síti eduroam.cz"},"website":{"ipv4":"IPv4","ipv6":"IPv6","dnssec":"Doména zabezpečena DNSSEC","domain":"Doména","https":"HTTPS"},"netmetr":{"download":"Download","upload":"Upload","ping":"Ping","link":"Měření na netmetr.cz","diff":"Rozdíl rychlostí"}},"intro":["Standard konektivity v rámci Integrovaného regionálního operačního programu (IROP) definuje základní technická kritéria pro projekty předložené ve výzvách č. [32](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-32-Infrastruktura-strednich-a-vyssich-odbo \"Infrastruktura středních škol a vyšších odborných škol\") a [33](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/33-vyzva-Infrastruktura-strednich-a-vyssich-odborn \"Infrastruktura středních škol a vyšších odborných škol (SVL)\") (SŠ, VOŠ), č. [46](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-46-Infrastruktura-zakladnich-skol \"Infrastruktura základních škol\") a [47](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-47-Infrastruktura-zakladnich-skol-SVL \"Infrastruktura základních škol (SVL)\") (ZŠ) a č. [66](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-66-Infrastruktura-pro-vzdelavani-integrova \"Infrastruktura pro vzdělávání - integrované projekty ITI\") a [67](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-67-Infrastruktura-pro-vzdelavani-integrova \"Infrastruktura pro vzdělávání - integrované projekty IPRÚ\") (ZŠ, SŠ a VOŠ) v rámci specifického cíle 2.4 IROP a dále ve výzvě č. [68](https://www.irop.mmr.cz/cs/Vyzvy/Seznam/Vyzva-c-68-Zvysovani-kvality-a-dostupnosti-Infrast \"Výzva č. 68 Zvyšování kvality a dostupnosti infrastrukt. pro vzdělávání a celož. učení - int.pr.CLLD\") (ZŠ, SŠ a VOŠ) v rámci specifického cíle 4.1 IROP.","Tato stránka je určena pro ty žadatele, kteří se ve svých projektech k naplnění požadavků tohoto standardu zavázali. Prostřednictvím této aplikace je možné vygenerovat potvrzení o splnění vybraných požadavků Standardu konektivity. Toto potvrzení tvoří nedílnou součást žádosti o platbu předkládanou Centru pro regionální rozvoj (CRR).","Webovou aplikaci je možné využít též na dobrovolném základě k ověření naplnění požadavků ze strany dodavatele a případnému zlepšení na požadovaný stav."]}}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./frontend/index.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// main.165ad1c4e46c170f2af2.js